import React, { useRef } from "react"
//import React, { useContext, useRef } from "react"
import Paper from "@material-ui/core/Paper"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography";

import useTickets from "../../hooks/useTicketsChart"

//import { AuthContext } from "../../context/Auth/AuthContext";

import { i18n } from "../../translate/i18n";

import Chart from "./Chart"
import ChartOut from "./ChartOut"

const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	fixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 240,
	},
	customFixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 120,
		//width: 80,
	},
	customFixedHeightPaperLg: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: "100%",
	},
}))

const Dashboard = () => {
	const classes = useStyles()

	//const { user } = useContext(AuthContext);
	//var userQueueIds = [];

	//console.log("user: ",user.id); //DESATEL 

	// if (user.queues && user.queues.length > 0) {
		// userQueueIds = user.queues.map(q => q.id);
	// }
	const date = useRef(new Date().toISOString());
	const GetTickets = (status, showAll, withUnreadMessages) => {
		//console.log("GetTickets"); //DESATEL 
		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			//userId: user.id,
			msg: "GetTickets"
			//queueIds: JSON.stringify(userQueueIds)
		});
		return count;
		//return 0;
	}
	
	const GetTickets2 = (status, showAll, withUnreadMessages) => {
		//console.log("GetTickets2"); //DESATEL 
		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			date: date.current,
			userId: 'notnull',
			msg: "GetTickets2"
			//queueIds: JSON.stringify(userQueueIds)
		});
		return count;
		//return 0;
	}
	
	const GetTickets3 = (status, showAll, withUnreadMessages) => {
		//console.log("GetTickets3"); //DESATEL 
		const { count } = useTickets({
			status: 'outclosed',
			showAll: showAll,
			date: date.current,
			userId: 'null',
			msg: "GetTickets3"
		});
		return count;
	}
	
	const GetTickets4 = (status, showAll, withUnreadMessages) => { //esperando se adiciona la cola
		//console.log("GetTickets4"); //DESATEL 
		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			//userId: user.id
			//queueIds: JSON.stringify(userQueueIds),
			msg: "GetTickets4"
		});
		return count;
	}
	
	const GetTickets5 = (status, showAll, withUnreadMessages) => { //bot y calidad
		//console.log("GetTickets5"); //DESATEL 
		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			//userId: user.id
			//queueIds: JSON.stringify(userQueueIds),
			msg: "GetTickets5"
		});
		return count;
	}

	return (
		<div>
			<p>. </p>
			<p><Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.title")}
							</Typography> </p>
			<Container maxWidth="lg" className={classes.container}>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.inAttendance.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets("open", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.waiting.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets4("pending", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.closed.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets2("closed", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.bot.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets5("bot", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.calidad.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets5("calidad", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.tmbot.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets3("closed", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.fixedHeightPaper}>
							<Chart />
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.fixedHeightPaper}>
							<ChartOut />
						</Paper>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

export default Dashboard



/*import React from "react";

import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Chart from "./Chart";

const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	fixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 240,
	},
}));

const Dashboard = () => {
	const classes = useStyles();
	return (
		<div>
			<Container maxWidth="lg" className={classes.container}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Paper className={classes.fixedHeightPaper}>
							<Chart />
						</Paper>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Dashboard;
*/